import { Grid } from "@mui/material";
import { useEffect, useReducer } from "react"
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert"
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer"
import StockLocationControlService from "./StockLocationControlService"
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import { IconSwitch } from "../../componentes/iconSwitch/IconSwitch";
import { DefaultDatagrid } from "../../componentes/datagrid/DefaultDatagrid";
import { DefaultAutocomplete } from "../../componentes/autocomplete/DefaultAutocomplete";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { ImageUploadCard } from "../../componentes/DragNDrop/ImageUploadCard";
import { GridColumnHeaderItem } from '@material-ui/data-grid';
import DefaultChip from "../../componentes/chip/DefaultChip";
import { Typography } from "@material-ui/core";


const columnsStockLocation = (t) => [
    { field: "id", flex: 0.5, visible: false },
    {
        field: "description",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="description" name="description"/>;
        },
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.description}
                        </Typography>}
                    />
                </>
            )
        }
    },
    { field: "idStorage", flex: 0.5, visible: false },
    {
        field: "storage",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="storage" name="address"/>;
        },
        flex: 1
    },
    { field: "idStreet", flex: 0.5, visible: false },
    {
        field: "street",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="street" name="map" />;
        },
        flex: 1
    },
    { field: "idColumn", flex: 0.5, visible: false },
    {
        field: "column",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="column" name="column"/>;
        },
        flex: 1
    },
    { field: "idLevel", flex: 0.5, visible: false },
    {
        field: "level",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="level" name="level" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="standard"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.level}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "barCode",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="barCode" name="code" />;
        },
        flex: 1,
        template: (props) => {
            return (
                <>
                    <DefaultChip
                        style="grey"
                        label={<Typography
                            variant="body3"
                            style={{ whiteSpace: 'normal' }}>{props.barCode}
                        </Typography>}
                    />
                </>
            )
        }
    },
    {
        field: "status",
        textAlign: "center",
        headerTemplate: () => {
            return <IconLabelSwitch isHeader={true} labelName="status" />;
        },
        flex: 0.5,
        template: (props) => {
            return (
                <>
                    {props.status ? (
                        <IconSwitch name="active" />
                    ) : (
                        <IconSwitch name="canceled" />
                    )}
                </>
            );
        },
    },
];

export const StockLocationRegister = ({ updateId }) => {

    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        id: 0,
        description: "",
        idStorage: 0,
        idStreet: 0,
        idColumn:0,
        idLevel:0,
        status:1,
        rows: [],
        userId: userId,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [StockLocationControl, dispatch] = useReducer(reducer, initialState);

    const { id, description, idStorage, idStreet, idColumn, idLevel, barCode, status } = StockLocationControl
    const { success, error, message, rows, ...data } = StockLocationControl

    useEffect(() => {
        updateId({ id: id })
    }, [id])

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } })
    }

    const handleSearch = () => {
        StockLocationControlService
            .getStockLocation(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'update', data: { rows: response.data } })
                }
            })
            .catch((e) => dispatch({ type: 'update', data: { rows: [] } }));
    }
    const canSave = () => description !== "" && idStorage !== 0 && idStreet !== 0 && idColumn !== 0 && idLevel !== 0 && status !== 2;

    const handleSaveUpdate = () => {
        if (canSave()) {
            if (id !== 0) {
                StockLocationControlService
                    .updateStockLocation(data)
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.result === null) 
                            {
                                dispatch({ type: 'success' })
                                handleSearch();
                            }
                            else
                            {
                                dispatch({type: 'update', data: {success: false, error: true, id: response.data.id, message: response.data.result } })
                            }
                        }
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
            else {
                StockLocationControlService
                    .createStockLocation(data)
                    .then((response) => {
                        if (response.status === 200) {
                            if (response.data.result === null) 
                            {
                                dispatch({ type: 'success' })
                                handleSearch();
                            }
                            else
                            {
                                dispatch({type: 'update', data: {success: false, error: true, id: response.data.id, message: response.data.result } })
                            }
                        }
                        
                    })
                    .catch((e) => dispatch({ type: 'error' }));
            }
        } else {
            dispatch({ type: 'error' })
        }

    }

    const handleCellClickStockLocation = (data) => {
        dispatch({
            type: 'update', data: {
                id: data.id,
                description: data.description,
                idStorage: data.idStorage,
                idStreet: data.idStreet,
                idColumn: data.idColumn,
                idLevel: data.idLevel,
                codebar: data.codeBar,
                status: data.status,
            }
        })
    }

    useEffect(() => {
        handleSearch();
    }, [])

    return (
        <>
            <DefaultScreenAccordion
                isTab
                fields={
                    <GridItemContainer>
                        <CustomAlert
                            success={success}
                            error={error}
                            message={message}
                            handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                        />
                        <Grid item xs={id !== 0 ? 7 : 12} sm={id !== 0 ? 8 : 12} md={id !== 0 ? 10 : 12}>
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <InputField
                                        iconLabelSwitch={
                                            <IconLabelSwitch name="description" labelName="description" />
                                        }
                                        name="description"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={description}
                                        inputProps={{ maxLength: 50 }}
                                        error={error && description === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"idStorage"}
                                        onChange={handleChange}
                                        placeholder={t("storage")}
                                        label={t("storage")}
                                        useApi
                                        endpoint='GetStorageAutoComplete'
                                        value={idStorage}
                                        defaultSize
                                        error={error && idStorage === 0}
                                    />
                                </Grid>
                            </GridInputRow>

                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"idStreet"}
                                        onChange={handleChange}
                                        placeholder={t("street")}
                                        label={t("street")}
                                        useApi
                                        endpoint='GetStreetAutoComplete'
                                        value={idStreet}
                                        defaultSize
                                        error={error && idStreet === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"idColumn"}
                                        onChange={handleChange}
                                        placeholder={t("column")}
                                        label={t("column")}
                                        useApi
                                        endpoint='GetColumnAutoComplete'
                                        value={idColumn}
                                        defaultSize
                                        error={error && idColumn === 0}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"idLevel"}
                                        onChange={handleChange}
                                        placeholder={t("level")}
                                        label={t("level")}
                                        useApi
                                        endpoint='GetLevelAutoComplete'
                                        value={idLevel}
                                        defaultSize
                                        error={error && idLevel === 0}
                                    />
                                </Grid>
                            </GridInputRow>
                                
                            <GridInputRow>
                                <Grid item xs={12} sm={6} md={4}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                        error={error && status === 2}
                                    />
                                </Grid>
                            </GridInputRow>
                        </Grid>
                        
                        <SearchClearSaveRow
                            onClickSearch={handleSearch}
                            onClickClear={() => dispatch({ type: 'clear' })}
                            onClickSave={handleSaveUpdate}
                        />
                        {(rows.length > 0) ? (
                            <GridInputRow>
                                <Grid item xs={12}>
                                    <DefaultDatagrid
                                        columns={columnsStockLocation(t)}
                                        dataSource={rows}
                                        allowPaging={true}
                                        cellSelected={(args, grid) =>
                                            handleCellClickStockLocation(args.data)
                                        } />
                                </Grid>
                            </GridInputRow>
                        ) : null}
                    </GridItemContainer>
                } />
        </>
    );
}